// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

export const stage = "qa";

var firebaseConfig = {
  apiKey: "AIzaSyD-OwDUWjmcY5EKg5jI44Yt81l-OlWO3qE",
  authDomain: "re2-qa.firebaseapp.com",
  projectId: "re2-qa",
  storageBucket: "re2-qa.appspot.com",
  messagingSenderId: "531646867919",
  appId: "1:531646867919:web:0dc4a433104439d95d8aba",
  measurementId: "G-2NGRG5VMC0",
};

console.log({ project: firebaseConfig.projectId });

// var firebaseConfig = {
//   apiKey: "AIzaSyCdQ1Uz3SeGA8nabbVuxtGsm6KFeQFlkvE",
//   authDomain: "re2-dev-380209.firebaseapp.com",
//   projectId: "re2-dev-380209",
//   storageBucket: "re2-dev-380209.appspot.com",
//   messagingSenderId: "782377233915",
//   appId: "1:782377233915:web:68e87c6d330de2ec65ef5e",
//   measurementId: "G-KN15LKR84V",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "asia-south1");
